<app-page>
    <app-title>{{ phoneNumber }}</app-title>
    <app-orders [ordersModel]="ordersModel"></app-orders>
</app-page>
